"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTO_PLAY_STOP_SHOW = exports.AUTO_PLAY_STOP_HIDE = exports.AUTO_PLAY_STOP = exports.AUTO_PLAY_ROUND_PLAYED = exports.AUTO_PLAY_FREE_SPIN_START = exports.AUTO_PLAY = void 0;
var AUTO_PLAY = exports.AUTO_PLAY = "AUTO_PLAY"; // starts autoplay
var AUTO_PLAY_ROUND_PLAYED = exports.AUTO_PLAY_ROUND_PLAYED = "AUTO_PLAY_ROUND_PLAYED";
var AUTO_PLAY_STOP = exports.AUTO_PLAY_STOP = "AUTO_PLAY_STOP";

// coins swipe, bonus game... to hide it during feature TODO revap
var AUTO_PLAY_STOP_HIDE = exports.AUTO_PLAY_STOP_HIDE = "AUTO_PLAY_STOP_HIDE";
var AUTO_PLAY_STOP_SHOW = exports.AUTO_PLAY_STOP_SHOW = "AUTO_PLAY_STOP_SHOW";

// Auto play free spins in games with manual free spins.
var AUTO_PLAY_FREE_SPIN_START = exports.AUTO_PLAY_FREE_SPIN_START = "AUTO_PLAY_FREE_SPIN_START";
//# sourceMappingURL=types.js.map